import styles from './PricePerDate.module.scss'

type PricePerDateProps = {
  totalPrice: string,
  numOfDates: number,
  productType: string,
}

// CRO-1240-Price-per-night
export function PricePerDate({ totalPrice, numOfDates, productType }: PricePerDateProps) {
  // Choose to display 'per night'
  const dateType = 'night'
  let totalText = ''

  // Adjust the text below price for hotel/room
  if (productType === 'hotel') {
    totalText = `For ${numOfDates}-${dateType} stay`
  } else if (productType === 'room') {
    totalText = `Total for ${numOfDates}-${dateType} stay ${totalPrice}`
  }

  const calculatePricePerDate = (total:string, dates:number) => {
    const calculatedPrice = parseInt(total, 10) / dates
    return Number(calculatedPrice).toFixed(2)
  }

  return (
    <div className={styles.perDateContainer}>
      <span className={styles.perDatePrice}>
        <strong>£{calculatePricePerDate(totalPrice, numOfDates)}</strong>
        <p>per {dateType}</p>
      </span>
      <span className={styles.total}>{totalText}</span>
      <em className={styles.termsText}>Includes taxes and charges</em>
    </div>
  )
}
